window.Page = {

    filtersGroups           : document.querySelectorAll('.filters-group'),
    filtersByType           : document.querySelectorAll('.filters-type input'),
    filtersTypeLegend       : document.querySelector('.filters-type legend'),
    filtersByCollection     : document.querySelectorAll('.filters-collection input'),
    filtersCollectionLegend : document.querySelector('.filters-collection legend'),

    // Let's launch this thing
    liftoff : () => {
        Page.showHideFilters()
        Page.filterProductsByType()
        Page.filterProductsByCollection()
    },

    // Show hide the filters when the section is clicked
    showHideFilters : () => {
        
        Page.filtersGroups.forEach(group => {
            group.addEventListener('click', () => {
                group.classList.toggle('filters-are-open')
            })
        })

    },

    // Update the filters based on the type
    filterProductsByType : () => {
        Page.filtersByType.forEach(filter => {
            filter.addEventListener('change' , () => {
                
                // Update the value of the legend
                Page.filtersTypeLegend.innerHTML = filter.dataset.text

                // Close the parent container
                filter.parentElement.classList.remove('filters-are-open')

                // Call the filter function
                Page.filterTheProducts()

            })
        })
    },

    // Update the filters based on the collection
    filterProductsByCollection : () => {
        Page.filtersByCollection.forEach(filter => {
            filter.addEventListener('change' , () => {
                
                // Update the value of the legend
                Page.filtersCollectionLegend.innerHTML = filter.dataset.text

                // Close the parent container
                filter.parentElement.classList.remove('filters-are-open')

                // Call the filter function
                Page.filterTheProducts()


            })
        })
    },

    // Actually filter the collection
    filterTheProducts : () => {

        // Grab the selected filters
        let typeSelected       = document.querySelector('.filters-type input:checked')
        let collectionSelected = document.querySelector('.filters-collection input:checked')

        // Grab an array copy of the cards
        let cards         = [...document.querySelectorAll('.product-card')];
        let cardsFiltered = [...document.querySelectorAll('.product-card')];

        // Now we need to filter the list based on what's currently selected
        if (typeSelected.value != 'all') {
            cardsFiltered = cardsFiltered.filter(card => {
                return card.classList.contains(typeSelected.value)
            });

            console.log(`TYPE: ${cardsFiltered}`)
        }

        if (collectionSelected.value != 'all') {
            cardsFiltered = cardsFiltered.filter(card => {
                return card.classList.contains(collectionSelected.value)
            });
            console.log(`COLLECTION: ${cardsFiltered}`)
        }

        if (typeSelected.value == 'all' && collectionSelected.value == 'all') {
            cards.forEach(card => { card.classList.remove('filtered')})
            console.log('CLEARED!')
            return;
        }

        cards.forEach(card   => { card.classList.add('filtered')})
        cardsFiltered.forEach(card => { card.classList.remove('filtered')})

    }

};

Page.liftoff()